import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_jrnl_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  guid_grp: fromDatatype.GuidDataFieldInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  reference_num_1: fromDatatype.BigIntegerDatatypeInterface;
  reference_num_2: fromDatatype.BigIntegerDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  amt_debit: fromDatatype.MoneyDatatypeInterface;
  amt_credit: fromDatatype.MoneyDatatypeInterface;
  jrnl_batch_guid: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  log_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  guid_generic_doc_hdr: fromDatatype.VarcharDatatypeInterface;
  guid_entity_hdr: fromDatatype.GuidDataFieldInterface;
  guid_entity_line: fromDatatype.GuidDataFieldInterface;
  date_txn_doc: fromDatatype.TimestampTzDatatypeInterface;
  date_posting: fromDatatype.TimestampTzDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  guid_comp: fromDatatype.GuidDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  ccy_code: fromDatatype.VarcharDatatypeInterface;
  doc_source_type: fromDatatype.VarcharDatatypeInterface;
  doc_source_url: fromDatatype.VarcharDatatypeInterface;
  doc_source_db: fromDatatype.VarcharDatatypeInterface;
  doc_source_guid: fromDatatype.GuidDataFieldInterface;
  doc_source_table: fromDatatype.VarcharDatatypeInterface;
  doc_source_software_name: fromDatatype.VarcharDatatypeInterface;
  doc_source_code: fromDatatype.VarcharDatatypeInterface;
  ds_property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  posting_running_no: fromDatatype.VarcharDatatypeInterface;
  posting_status: fromDatatype.VarcharDatatypeInterface;
  auto_flag: boolean;
  server_doc_type: fromDatatype.VarcharDatatypeInterface;
  server_doc_1: fromDatatype.VarcharDatatypeInterface;
  server_doc_2: fromDatatype.VarcharDatatypeInterface;
  server_doc_3: fromDatatype.VarcharDatatypeInterface;
  server_doc_4: fromDatatype.VarcharDatatypeInterface;
  server_doc_5: fromDatatype.VarcharDatatypeInterface;
  client_doc_type: fromDatatype.VarcharDatatypeInterface;
  client_doc_1: fromDatatype.VarcharDatatypeInterface;
  client_doc_2: fromDatatype.VarcharDatatypeInterface;
  client_doc_3: fromDatatype.VarcharDatatypeInterface;
  client_doc_4: fromDatatype.VarcharDatatypeInterface;
  client_doc_5: fromDatatype.VarcharDatatypeInterface;
  fiscal_period_guid: fromDatatype.GuidDataFieldInterface;
  fiscal_year_guid: fromDatatype.GuidDataFieldInterface;
  guid_branch: fromDatatype.GuidDataFieldInterface;
  ledger_hdr_guid: fromDatatype.GuidDataFieldInterface;
  far_hdr_guid: fromDatatype.GuidDataFieldInterface;
  posting_running_no_by_company: fromDatatype.VarcharDatatypeInterface;
}

export class bl_fi_jrnl_hdr_RowClass
  implements bl_fi_jrnl_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  guid_grp: fromDatatype.GuidDataFieldInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  reference_num_1: fromDatatype.BigIntegerDatatypeInterface;
  reference_num_2: fromDatatype.BigIntegerDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  amt_debit: fromDatatype.MoneyDatatypeInterface;
  amt_credit: fromDatatype.MoneyDatatypeInterface;
  jrnl_batch_guid: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  log_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  guid_generic_doc_hdr: fromDatatype.VarcharDatatypeInterface;
  guid_entity_hdr: fromDatatype.GuidDataFieldInterface;
  guid_entity_line: fromDatatype.GuidDataFieldInterface;
  date_txn_doc: fromDatatype.TimestampTzDatatypeInterface;
  date_posting: fromDatatype.TimestampTzDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  guid_comp: fromDatatype.GuidDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  ccy_code: fromDatatype.VarcharDatatypeInterface;
  doc_source_type: fromDatatype.VarcharDatatypeInterface;
  doc_source_url: fromDatatype.VarcharDatatypeInterface;
  doc_source_db: fromDatatype.VarcharDatatypeInterface;
  doc_source_guid: fromDatatype.GuidDataFieldInterface;
  doc_source_table: fromDatatype.VarcharDatatypeInterface;
  doc_source_software_name: fromDatatype.VarcharDatatypeInterface;
  doc_source_code: fromDatatype.VarcharDatatypeInterface;
  ds_property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  posting_running_no: fromDatatype.VarcharDatatypeInterface;
  posting_status: fromDatatype.VarcharDatatypeInterface;
  auto_flag: boolean;
  server_doc_type: fromDatatype.VarcharDatatypeInterface;
  server_doc_1: fromDatatype.VarcharDatatypeInterface;
  server_doc_2: fromDatatype.VarcharDatatypeInterface;
  server_doc_3: fromDatatype.VarcharDatatypeInterface;
  server_doc_4: fromDatatype.VarcharDatatypeInterface;
  server_doc_5: fromDatatype.VarcharDatatypeInterface;
  client_doc_type: fromDatatype.VarcharDatatypeInterface;
  client_doc_1: fromDatatype.VarcharDatatypeInterface;
  client_doc_2: fromDatatype.VarcharDatatypeInterface;
  client_doc_3: fromDatatype.VarcharDatatypeInterface;
  client_doc_4: fromDatatype.VarcharDatatypeInterface;
  client_doc_5: fromDatatype.VarcharDatatypeInterface;
  fiscal_period_guid: fromDatatype.GuidDataFieldInterface;
  fiscal_year_guid: fromDatatype.GuidDataFieldInterface;
  guid_branch: fromDatatype.GuidDataFieldInterface;
  ledger_hdr_guid: fromDatatype.GuidDataFieldInterface;
  far_hdr_guid: fromDatatype.GuidDataFieldInterface;
  posting_running_no_by_company: fromDatatype.VarcharDatatypeInterface;
}
